export const MODULOS_TAGS = {
  PLATAFORMACLIENTE: 'plataforma_cliente',
  PLATAFORMA_CRM: 'plataforma_crm',
  PLATAFORMA_FORMALIZACAO: 'plataforma_formalizacao',
  PLATAFORMA_RELACIONAMENTOS: 'plataforma_relacionamento',
  PLATAFORMA_CAPITAL_FLOW: 'plataforma_capital_flow',
  PLATAFORMA_ONESHELL: 'plataforma_oneshell'
};

export const MODULOS = {
  PLATAFORMACLIENTE: 24,
  PLATAFORMA_CRM: 35,
  PLATAFORMA_FORMALIZACAO: 36,
  PLATAFORMA_RELACIONAMENTOS: 42,
  PLATAFORMA_CAPITAL_FLOW: 44,
  PLATAFORMA_ONESHELL: 45
};
